import React from 'react';
import { cn } from '@/lib/utils';
import { ExpenseStatus, EXPENSE_STATUS_INFO } from '@/types/expense';

interface ExpenseStatusBadgeProps {
  status: ExpenseStatus;
  size?: 'sm' | 'md' | 'lg';
  showIcon?: boolean;
  className?: string;
}

const ExpenseStatusBadge: React.FC<ExpenseStatusBadgeProps> = ({
  status,
  size = 'md',
  showIcon = true,
  className
}) => {
  const statusInfo = EXPENSE_STATUS_INFO[status];
  
  const sizeClasses = {
    sm: 'px-2 py-1 text-xs',
    md: 'px-3 py-1 text-sm',
    lg: 'px-4 py-2 text-base'
  };

  const colorClasses = {
    gray: 'bg-gray-100 text-gray-800 border-gray-200',
    yellow: 'bg-yellow-100 text-yellow-800 border-yellow-200',
    green: 'bg-green-100 text-green-800 border-green-200',
    red: 'bg-red-100 text-red-800 border-red-200',
    blue: 'bg-blue-100 text-blue-800 border-blue-200'
  };

  return (
    <span
      className={cn(
        'inline-flex items-center gap-1 font-medium rounded-full border',
        sizeClasses[size],
        colorClasses[statusInfo.color],
        className
      )}
      title={statusInfo.description}
    >
      {showIcon && (
        <span className="inline-block" aria-hidden="true">
          {statusInfo.icon}
        </span>
      )}
      <span>{statusInfo.label}</span>
    </span>
  );
};

export default ExpenseStatusBadge; 